import { render, staticRenderFns } from "./simple-dialog.vue?vue&type=template&id=431b35f2&"
import script from "./simple-dialog.vue?vue&type=script&lang=ts&"
export * from "./simple-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./simple-dialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VOverlay})
